export * from './actions-list.graphql';
